import React, { useCallback, useMemo, useState } from "react";
import { Button, DialogActions, DialogContent, DialogTitle, TextareaAutosize } from "@material-ui/core";

interface Props {
    open: boolean;
    onSubmit: (notes: string) => void;
    onCancel: () => void;
}

export function NotesDialog({ open, onSubmit, onCancel }: Props) {
    const [value, setValue] = useState("");
    const disabled = useMemo(() => value.trim().length === 0, [value]);
    const handleSubmit = useCallback(() => {
        if (!disabled) onSubmit(value.trim());
    }, [disabled, onSubmit, value]);
    return (
        <>
            <DialogTitle>Reason for a Manual Override</DialogTitle>
            <DialogContent>
                <TextareaAutosize
                    style={{ width: "90%" }}
                    value={value}
                    rows={5}
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setValue(e.currentTarget.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button color="primary" variant="contained" disabled={disabled} onClick={handleSubmit}>Submit</Button>
                <Button onClick={onCancel}>Cancel</Button>
            </DialogActions>
        </>
    );
}

